import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { Cart } from '@spartacus/cart/base/root'

export const MB_CHECKOUT_REVIEW_PRICES_NORMALIZER = new InjectionToken<Converter<any, Cart>>('MbCheckoutReviewPricesNormalizer')
